const MODULE = "CONTACT";

export const CHANGE_VALUE = `${MODULE}change-value`;
export type CHANGE_VALUE = typeof CHANGE_VALUE;

export const INIT_FORM = `${MODULE}init-form`;
export type INIT_FORM = typeof INIT_FORM;

export const SUBMIT_FORM = `${MODULE}submit-form`;
export type SUBMIT_FORM = typeof SUBMIT_FORM;